type SectionHeadingProps = {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({
  index,
  kicker,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const centered = align === 'center';

  return (
    <div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      <div
        className={`flex items-center gap-3 ${centered ? 'justify-center' : ''}`}
      >
        <span className="font-label text-xs font-semibold tracking-[0.3em] text-primary-600">
          {index}
        </span>
        <span className="h-px w-8 bg-primary-300" />
        <span className="font-label text-xs font-medium tracking-[0.2em] text-foreground-500">
          {kicker}
        </span>
      </div>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
          {desc}
        </p>
      )}
    </div>
  );
}